import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateService } from './core/services/translate.service';
import { provideState, provideStore } from '@ngrx/store';
import { AUTH_FEATURE_KEY } from './core/auth/consts/auth.constants';
import { authReducer } from './core/auth/state/auth.reducer';
import { authInterceptor } from './core/interceptors/auth-interceptor';
import { provideEffects } from '@ngrx/effects';
import { AuthEffects } from './core/auth/state/auth.effect';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(() => {
      const translateService = inject(TranslateService);
      return translateService.loadDefaultTranslations();
    }),
    provideStore(),
    provideState({ name: AUTH_FEATURE_KEY, reducer: authReducer }),
    provideEffects(AuthEffects),
  ],
};
